import { Component, OnInit } from '@angular/core';
import { AngularFirestoreCollection, AngularFirestore, DocumentSnapshot } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AngularFireFunctions } from '@angular/fire/functions';
import { finalize } from 'rxjs/operators';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-tropas',
  templateUrl: './tropas.component.html',
  styleUrls: ['./tropas.component.scss']
})
export class TropasComponent implements OnInit {

  private itemsCol: AngularFirestoreCollection<any>;
  public  items:    Observable<any>;
  public  item: any;
  public  exist: boolean;
  public view:boolean;
  public lastURL:string;

  private validacionesCol: AngularFirestoreCollection<any>;
  private validaciones: Observable<any>;

  private solicitudesCol: AngularFirestoreCollection<any>;
  private solicitudes: Observable<any>;

  public displayedColumns = ["cedula", "nombre", "celular", /*"totalSimcards", "",*/ "options" ];

  public fnExportTropas: (data: any) => Observable<any>;
  public busy:boolean = false;

  constructor(private afFunctions: AngularFireFunctions,
    private afFirestore: AngularFirestore,
    public authService: AuthService,
    private snackBar: MatSnackBar) {

  }

  ngOnInit() {
    this.itemsCol        = this.afFirestore.collection<any>("tropa");
    this.items           = this.itemsCol.valueChanges();    
    this.fnExportTropas  = this.afFunctions.httpsCallable('fileExports-exportTropas', {timeout: 2*540000});
  }

  showList(){
    this.item = null;
  }

  showCreate(){
    this.exist = false;
    this.item = {
      cedula: "",
      nombre: "",
      celular: ""      
    };
  }  

  showUpdate(item){
    this.view = false;
    this.exist = true;    
    this.item = {...item};
  }

  showView(item){
    this.view = true;
    this.item = item;    
    this.validacionesCol   = this.afFirestore.collection<any>("validaciones", ref=> ref.where("solicitaCedula", "==", this.item["cedula"]) );
    this.validaciones      = this.validacionesCol.valueChanges();
    this.validaciones.subscribe(
      (lastValidaciones)=>{
        item["validacionesSi"]    = 0;
        item["validacionesNo"]    = 0;
        item["validacionesTotal"] = 0;
        lastValidaciones.forEach(
          (validacion)=>{               
            if( validacion["estado"] === "resuelto" ){
              if( validacion["aplica"] === "NO" ){
                item["validacionesNo"]++;
              }
              else{
                item["validacionesSi"]++;
              }
            }            
            item["validacionesTotal"]++;
          }
        );        
      }
    );
    
    this.solicitudesCol   = this.afFirestore.collection<any>("solicitudes-nip", ref=> ref.where("solicitaCedula", "==", this.item["cedula"]) );
    this.solicitudes      = this.solicitudesCol.valueChanges();
    this.validaciones.subscribe(
      (lastValidaciones)=>{
        item["nipOk"]    = 0;
        item["nipError"] = 0;
        item["nipTotal"] = 0;
        lastValidaciones.forEach(
          (validacion)=>{               
            if( validacion["error"] !== undefined ){
              item["nipError"]++;
            }
            else{
              item["nipOk"]++;
            }                        
            item["nipTotal"]++;
          }
        );        
      }
    );
  }

  create(){
    var itemRef = this.itemsCol.doc(""+this.item.cedula).ref;
    itemRef.get()
      .then(
        (documentSnapshot: DocumentSnapshot<any>)=>{
          if( documentSnapshot.exists ){
            this.snackBar.open("Ya existe un vendedor tropa con la cedula: "+this.item.cedula,"Entiendo",{duration: 2000});
          }
          else{
            itemRef.set(this.item, { merge: true })
              .then(
                ()=>{
                  this.showList();
                }
              );
          }
        }
      )
      .catch(
        (error)=>{
          this.snackBar.open("Error inesperado creando el vendedor tropa","Entiendo",{duration: 2000});
        }
      );  
  }

  update(){
    var itemRef = this.itemsCol.doc(""+this.item.cedula).ref;
    itemRef.set(this.item, { merge: true })
      .then(
        ()=>{
          this.showList();
        }
      )
      .catch(
        (error)=>{
          this.snackBar.open("Error inesperado actualizando el vendedor tropa","Entiendo",{duration: 2000});
        }
      );  
  }

  showDelete(item){
    if(confirm("¿Esta seguro de querer eliminar a este vendedor tropa?")){
      var itemRef = this.itemsCol.doc(""+item.cedula).ref;      
      itemRef.delete()
        .then(
          ()=>{
            this.showList();
          }
        )
        .catch(
          (error)=>{
            this.snackBar.open("Error inesperado eliminando el vendedor tropa","Entiendo",{duration: 2000});
          }
        );
    }
  }

  fixValue(value){
    return value !== undefined ? value : 0; 
  }
  
  createFile(){
    this.busy = true;
    this.fnExportTropas({}).toPromise()
    .then(
      (url:string) => {        
        console.log(url);
        this.lastURL = url;
        this.busy = false; 
        window.open(url, "_blank");
      }
    )
    .catch(
      (fnError) => {                
        //TODO: Buscar como se devuelve el error con este tema de los promises
        this.busy = false;
        console.table(fnError);
        console.log(fnError);
        this.snackBar.open("Error inesperado descargando el archivo, intente nuevamente","Entiendo",{duration: 2000});
      }
    );
  }  

}
